// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__373D-","label":"Radio_label__L7pRy","checkMark":"Radio_checkMark__1uQ5G","disabled":"Radio_disabled__3_qIK"};